import isObject from 'is-object';

function withCtxQueryValidation({
  validations = {},
  abortOnInvalid = true,
  statusCode = 406 // https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/406
} = {}) {
  return async (ctx, next) => {
    ctx.invalidQueryParams = ctx.invalidQueryParams || [];
    Object.keys(validations).forEach(key => {
      // determine that query has the parameter to validate
      const hasValue = Object.prototype.hasOwnProperty.call(ctx.query, key);
      if (hasValue) {
        // get the parameter value
        const value = ctx.query[key];
        const options = {
          test: () => {},
          required: false,
          statusCode: 406
        };
        const validator = validations[key];

        // if the validator argument is a function
        // assign it as the test method
        if (typeof validator === 'function') {
          options.test = validator;
        }

        // if the validator is an object
        // extract the test property as the test method
        if (isObject && typeof validator.test === 'function') {
          Object.assign(options, validator);
        }
        const isInvalid = !options.test(value, ctx);
        if (isInvalid) {
          // push the invalid key to ctx
          ctx.invalidQueryParams.push(key);

          // remove invalid paramto protect downstream consumers
          delete ctx.query[key];
          if (options.required && abortOnInvalid) {
            // if we are on the server set the response statusCode
            if (ctx.res) {
              ctx.res.statusCode = statusCode;
            }

            // set statusCode on ctx
            ctx.statusCode = statusCode;

            // abort remaining context middleware queue
            next(`query param ${key} has invalid value: ${value}`);
          }
        }
      }
    });
    ctx.registerMiddleware('query-validation');
  };
}

export { withCtxQueryValidation };
